import { bindable, bindingMode } from 'aurelia-framework';
import 'jquery';

const $ = jQuery;

export class ReadMore {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) text: String;

    constructor() {
    }

    paragraphElement: HTMLElement;

    toggle(e) {
        $(this.paragraphElement).toggleClass('read-less');
        if ($(e).text() == 'Show Less') $(e).text('Show More');
        else $(e).text('Show Less');
    }
}